//Custom.ts =================================================
import "./Util/Prototypes";

import * as Carousel from "./Util/Carousel";
import * as CommunityInfo from "./Widgets/CommunityInfo";
import * as DataTable from "./Util/DataTable";
import * as DrawerMenu from "./Menus/DrawerMenu";
import * as MainMap from "./MainMap";
import * as SalesSearchSettings from "./Sales Search/SalesSearchSettings";
import * as Search from "./Search/Search";
import * as Settings from "./Settings";
import * as TaxValuesPopup from "./Util/TaxValuesPopup";
import * as Util from "./Util/Util";
import * as Util_App from "./Util/Util_App";

//import AttachmentQuery from "@arcgis/core/rest/support/AttachmentQuery";
import Point from "@arcgis/core/geometry/Point";
//import * as projection from "@arcgis/core/geometry/projection";
//import SpatialReference from "@arcgis/core/geometry/SpatialReference";
//import WMTSSublayer from "@arcgis/core/layers/support/WMTSSublayer";

//Set custom hyperlink at the top of the results list.
export function getCustomLinks(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet) {
   const vals: string[] = [];
   const urls: string[] = [];
   if (!feature) {
      return { values: vals, urls: urls };
   }

   const fields: __esri.Field[] = fs.fields;
   const atrs: any = feature.attributes;
   let title: string = "";
   let popupSpec: Settings.iPopUpTable;
   let url: string;
   let links: string;
   let fsLinks: string[];
   let pin: string;
   let centerPnt: __esri.Point;

   //Get mbr.
   let mbr: __esri.Extent;
   if (feature.geometry && feature.geometry.extent) {
      mbr = feature.geometry.extent;
   }

   //Parcels.
   if (layerName === "Parcel Info") {
      pin = Util_App.getGraphicAttributeValue("APN", feature) as string;

      if (mbr) {
         centerPnt = Util_App.getPointInsidePolygon(feature.geometry as __esri.Polygon);
      }

      //Property report.
      //vals.Add("Property Report");
      //url = Settings.webServerURL + "/Property_Report_TS/Default.aspx?pin=" + pin + "&isTinyScreen=" + false;
      //urls.Add(url);

      //Community info.
      if (mbr) {
         vals.Add("Community Info");
         url = "js:showCommunityInfo|" + centerPnt.x + "," + centerPnt.y;
         urls.Add(url);
      }

      ////Code Descriptions CUSTOM! Poway
      //vals.Add("Additional Parcel Information");
      //url = Settings.webServerURL + "/Local Data/Documents/Parcel_Metadata.pdf";
      //urls.Add(url);

      //APN Map CUSTOM! Poway
      vals.Add("APN Map");
      url = "https://assr.parcelquest.com/impl/sdxassr";
      urls.Add(url);

      // Link to Parcel Manager in EnerGov. CUSTOM! Poway
      if (Settings.security.accessLevel >= 25) {
         vals.Add("Parcel Manager");
         url = "https://cityofpowayca-energov.tylerhost.net/apps/maps/#/parcel/" + pin;
         urls.Add(url);
      }

      //All Addresses CUSTOM! Poway.
      if (Settings.security.accessLevel >= 1) {
         title = "All Addresses";
         popupSpec = Util_App.getDataTableSpec(title);

         if (popupSpec) {
            vals.Add(title);
            url = "js:showDataTable|" + title + "," + pin;
            urls.Add(url);
         }
      }
   } //End if layername parcels.

   //Benchmarks.
   if (layerName === "Benchmarks") {
      pin = Util_App.getGraphicAttributeValue("BenchMarkNum", feature) as string;

      //Benchmarks data sheet.
      vals.Add("Data Sheet");
      url = Settings.webServerURL + "/Local Data/Benchmarks/" + pin.replace("-", "") + ".pdf";
      urls.Add(url);
   }

   //Memorial Trees.
   if (layerName === "Memorial Trees") {
      let lat: any;
      let long: any;

      lat = Util_App.getGraphicAttributeValue("POINT_Y", feature);
      long = Util_App.getGraphicAttributeValue("POINT_X", feature);

      //Benchmarks data sheet.
      vals.Add("Google Earth");
      url = "https://earth.google.com/web/search/" + lat + "," + long + "/";
      urls.Add(url);
   }

   //Pictometry.
   //if (Settings.security.accessLevel >= 1) {
   //   vals.Add("Oblique Photos");

   //   const outSpatialReference = new SpatialReference({ wkid: 4326 });
   //   const geom = projection.project(centerPnt, outSpatialReference) as __esri.Point;

   //   url = Settings.webServerURL + "/PictometryIPA" + "?Lat=" + geom.y + "&Lon=" + geom.x;
   //   urls.Add(url);
   //}

   //Attachments.
   //if (layerName === "some_layer") {
   //   const objectId: number = Util_App.getObjectId(feature);
   //   vals.Add("Tif Attachment");
   //   url = "js:showAttachment|" + layerName + "," + objectId;
   //   urls.Add(url);
   //}

   if (vals.length !== urls.length) {
      alert("Error: The number of custom links does not match the number of custom values");
   }
   return { values: vals, urls: urls };
}

//Set custom field value in the results list.
export function getCustomValueFeature(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet) {
   let outVal: any = fieldValue;
   let pin: string;
   let txt: string;
   let pud: string;
   let url = "";

   //url = Util_App.getGraphicAttributeValue("DeedLink", feature) as string;

   //PlanNumber links. CUSTOM! Poway
   if (fieldName.Equal("PlanNumber")) {
      url = Util_App.getGraphicAttributeValue("PlanNumber", feature);

      if (url) {
         if (url.length > 4 && url.length - url.lastIndexOf("_") === 4) {
            url = url.slice(0, - 4);
         }
         if (layerName === 'Structural BMP' || layerName === 'SUSMP Maintenance Agreements') {
            url = Settings.webServerURL + "/Local Data/SUSMP Maintenance Agreements/" + url + ".pdf";
         } else {
            url = Settings.webServerURL + "/Local Data/EngineeringDrawingScans/ALL SCANNED PDFS/" + url + ".pdf";
         }
      } else {
         outVal = "Not available";
      }

      //ProjectNumber links. CUSTOM! Poway
   } else if (fieldName.Equal("ProjectNumber")) {
      url = Util_App.getGraphicAttributeValue("ProjectNumber", feature);

      if (url) {
         if (url.length > 4 && url.length - url.lastIndexOf("_") === 4) {
            url = url.slice(0, - 4);
         }
         url = Settings.webServerURL + "/Local Data/EngineeringDrawingScans/ALL SCANNED PDFS/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //SourceDocNumber links. CUSTOM! Poway
   } else if (fieldName.Equal("SourceDocNumber")) {
      url = Util_App.getGraphicAttributeValue("SourceDocNumber", feature);

      if (url) {
         if (url.length > 4 && url.length - url.lastIndexOf("_") === 4) {
            url = url.slice(0, - 4);
         }
         url = Settings.webServerURL + "/Local Data/EngineeringDrawingScans/ALL SCANNED PDFS/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //Certificate links. CUSTOM! Poway
   } else if (fieldName.Equal("Certificate")) {
      url = Util_App.getGraphicAttributeValue("Certificate", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/VeteransParkTiles/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //PrePlanNo links. CUSTOM! Poway
   } else if (fieldName.Equal("PrePlanNo")) {
      url = Util_App.getGraphicAttributeValue("PrePlanNo", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/PRE PLAN FILES/" + url + "/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //AdditionalInfo links. CUSTOM! Poway
   } else if (fieldName.Equal("AdditionalInfo")) {
      url = Util_App.getGraphicAttributeValue("AdditionalInfo", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/VeteransParkTiles/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //Photo links. CUSTOM! Poway
   } else if (fieldName.Equal("Photo")) {
      url = Util_App.getGraphicAttributeValue("Photo", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/Benchmarks/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //ReportNumber links. CUSTOM! Poway
   } else if (fieldName.Equal("ReportNumber")) {
      url = Util_App.getGraphicAttributeValue("ReportNumber", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/Environmental Assessments/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //ElevationCertificate links. CUSTOM! Poway
   } else if (fieldName.Equal("ElevationCertificate")) {
      url = Util_App.getGraphicAttributeValue("ElevationCertificate", feature);

      if (url) {
         url = Settings.webServerURL + "/Local Data/Elevation Certificates/" + url + ".pdf";
      } else {
         outVal = "Not available";
      }

      //Memorial Tree Species 1 links. CUSTOM! Poway
   } else if (fieldName.Equal("SppPlant1")) {
      url = Util_App.getGraphicAttributeValue("SppPlant1_URL", feature);

      if (!url) {
         outVal = "Not available";
      }

      //Memorial Tree Species 2 links. CUSTOM! Poway
   } else if (fieldName.Equal("SppPlant2")) {
      url = Util_App.getGraphicAttributeValue("SppPlant2_URL", feature);

      if (!url) {
         outVal = "Not available";
      }
   }

   return { value: outVal, url: url };
}

//Set custom no value text for community info.
export function getCustomNoValueText(description: string): string {
   let outVal: string = "Not available";

   //CUSTOM! Poway
   if (description.Equal("Within HCP Mitigation Area")) {
      outVal = "No";

   } else if (description.Equal("Within Specific Planning Area")) {
      outVal = "No";

   } else if (description.Equal("Within Hillside Review Area")) {
      outVal = "No";

   } else if (description.Equal("Within Historically Sensitive Area")) {
      outVal = "No";

   } else if (description.Equal("Within Old Coach Sierra Club Mitigation Area")) {
      outVal = "No";

   } else if (description.Equal("Fire Hazard Severity Zone")) {
      outVal = "NA";

   } else if (description.Equal("Within Brownfields EPA Grant Area")) {
      outVal = "No";

   }

   return outVal;
}

//Initialize custom layer properties.
export function setLayerProps(layer: any) {
   let sym: any;

   //CUSTOM! Poway
   if (layer.id.Equal("Latest Nearmap Imagery")) {
      /*layer.sublayers = [{ name: "Nearmap/Nearmap/USA" }];*/
      layer.sublayers = [{ name: "area/100d9d72-4963-4d88-a71a-78ebee20f893/all/all-combined" }];
      layer.spatialReference = { wkid: 26911 };
   }

   //CUSTOM! Poway
   //if (layer.id.Equal("Incident Points")) {
   //   const renderer = {
   //      type: "simple",
   //      symbol: {
   //         type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
   //         style: "circle",
   //         color: "blue",
   //         size: "12px",
   //      }
   //   };
   //   layer.renderer = renderer;
   //}

   //if (layer.id.Equal("Incident Lines")) {
   //   const renderer = {
   //      type: "simple",
   //      symbol: {
   //         type: "simple-line",  // autocasts as new SimpleLineSymbol()
   //         color: "blue",
   //         width: "4px",
   //         style: "short-dash"
   //      }
   //   };
   //   layer.renderer = renderer;
   //}

   //if (layer.id.Equal("Incident Areas")) {
   //   const renderer = {
   //      type: "simple",
   //      symbol: {
   //         type: "simple-fill",  // autocasts as new SimpleFillSymbol()
   //         color: [0, 0, 0, 0],
   //         style: "solid",
   //         outline: {  // autocasts as new SimpleLineSymbol()
   //            color: "blue",
   //            width: "4px",
   //            style: "short-dash"
   //         }
   //      }
   //   };
   //   layer.renderer = renderer;
   //}

   if (layer.id.Equal("Electrical Substations")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            style: "square",
            color: "yellow",
            size: "18px",
            outline: {  // autocasts as new SimpleLineSymbol()
               color: "#000000",
               width: "3px"
            }
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Electric Substations")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            style: "square",
            color: "yellow",
            size: "20px",
            outline: {  // autocasts as new SimpleLineSymbol()
               color: "#000000",
               width: "3px"
            }
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Electric Transmission Lines")) {
      const renderer = {
         type: "unique-value",
         legendOptions: {
            title: "Overhead or Underground"
         },
         field: "AssetOHUG",
         uniqueValueInfos: [{
            value: "Overhead",
            label: "Overhead",
            symbol: {
               type: "simple-line",
               color: "#E60073",
               width: "2.5px",
               style: "solid"
            }
         }, {
            value: "Underground",
            label: "Underground",
            symbol: {
               type: "simple-line",
               color: "#E60073",
               width: "2.5px",
               style: "short-dash"
            }
         }]
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Electric Distribution Lines")) {
      const renderer = {
         type: "unique-value",
         legendOptions: {
            title: "Overhead or Underground"
         },
         field: "AssetOHUG",
         uniqueValueInfos: [{
            value: "Overhead",
            label: "Overhead",
            symbol: {
               type: "simple-line",
               color: "#FF5500",
               width: "2.5px",
               style: "solid"
            }
         }, {
            value: "Underground",
            label: "Underground",
            symbol: {
               type: "simple-line",
               color: "#FF5500",
               width: "2.5px",
               style: "short-dash"
            }
         }]
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Sewer Manhole SD") || layer.id.Equal("Wastewater Manhole CN")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            style: "circle",
            color: "white",
            outline: {
               type: "simple-line",
               color: "black",
               style: "solid",
               width: .5
            },
            size: "12px",
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Sewer Main SD") || layer.id.Equal("Wastewater Gravity Main CN")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-line",  // autocasts as new SimpleLineSymbol()
            color: "#4CE600",
            width: "3px",
            style: "solid",
            marker: {
               color: "#FF0000",
               placement: "end",
               style: "arrow",
            },
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Wastewater Cleanout CN")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            style: "circle",
            color: "#FFFF00",
            outline: {
               type: "simple-line",
               color: "black",
               style: "solid",
               width: .5
            },
            size: "12px",
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Wastewater Pipe CN")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-line",  // autocasts as new SimpleLineSymbol()
            color: "#4CE600",
            width: "1.2px",
            style: "solid",
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Wastewater Pressurized Main CN")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-line",  // autocasts as new SimpleLineSymbol()
            color: "#00734C",
            width: "3.25px",
            style: "solid",
            marker: {
               color: "#FF0000",
               placement: "end",
               style: "arrow",
            },
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Water Hydrants SD")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
            style: "circle",
            color: "#E60000",
            outline: {
               type: "simple-line",
               color: "black",
               style: "solid",
               width: .5
            },
            size: "12px",
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Water Main SD")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-line",  // autocasts as new SimpleLineSymbol()
            color: "#004DA8",
            width: "1.7px",
            style: "solid",
         }
      };
      layer.renderer = renderer;
   }

   if (layer.id.Equal("Recycled Water Main SD")) {
      const renderer = {
         type: "simple",
         symbol: {
            type: "simple-line",  // autocasts as new SimpleLineSymbol()
            color: "#A900E6",
            width: "1.7px",
            style: "solid",
         }
      };
      layer.renderer = renderer;
   }
}

//Set custom vector tile layer symbology styles, etc.
export function setVectorTileLayerProps(vectorTileLayer: __esri.VectorTileLayer) {

   //Convert ESRI world street map to Google Maps symbology.
   if (vectorTileLayer.id.Equal("World Street Map (Default)")) {
      const styleLayers = vectorTileLayer.currentStyleInfo.style.layers;
      //Util.errMsg("Vector Tile styleLayers: " + vectorTileLayer.id, styleLayers);

      for (const sl of styleLayers) {
         const styleLayer = vectorTileLayer.getStyleLayer(sl.id);

         if (styleLayer.id === "Vegetation small scale/High density") { //Trees.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#D3F8E2";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Land/Not ice") { //Land and trees.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#D3F8E2";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Vegetation small scale/Low density") { //Trees.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#BCF0D1";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Admin0 forest or park") { //Dark trees.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#BCF0D1";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Water area large scale/Lake or river") { //Zoomed out lakes.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#90DAEE";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Water area/Lake, river or bay") { //Zoomed in lakes.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#90DAEE";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

         } else if (styleLayer.id === "Urban area") { //City polygons.
            const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            paintProperties["fill-color"] = "#F4DE75";
            vectorTileLayer.setPaintProperties(sl.id, paintProperties);

            //} else if (styleLayer.id === "Admin1 forest or park") { //Parks.
            //const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
            //paintProperties["fill-color"] = "#ff0000";
            //vectorTileLayer.setPaintProperties(sl.id, paintProperties);

            //} else if (styleLayer.id === "Openspace or forest") { //Not seeing it.
            //} else if (styleLayer.id === "Park or farming") { //Not seeing it.
            //} else if (styleLayer.id === "Golf course") {
            //} else if (styleLayer.id === "Building/outer shadow") {
            //} else if (styleLayer.id === "Building/inner shadow") {
            //} else if (styleLayer.id === "Building/fill") {
         }
         //   Util.errMsg(styleLayer.id + ": ", styleLayer);
      }

      //let newStyle = JSON.parse(JSON.stringify(vectorTileLayer.currentStyleInfo.style)); //Clone it.
      ////vectorTileLayer.loadStyle(newStyle);

      //vectorTileLayer.loadStyle(newStyle).then(() => {
      //   console.log("Style applied successfully!");
      //}).catch((error) => {
      //   console.error("Error applying style:", error);
      //});

      //Util.errMsg("Current Style", vectorTileLayer.currentStyleInfo.style);
      //Util.errMsg("newStyle", newStyle);


      //vectorTileLayer.setStyleLayerVisibility(sl.id, "visible");
      //vectorTileLayer.setStyleLayerVisibility(sl.id, "none");

   } else if (vectorTileLayer.id.Equal("Bla Bla")) {
      vectorTileLayer.maxScale = 60000;
   }
}

//Set custom visibility for field names in point feature layer labels.
export function getCustomLabelFieldNameVisibility(layerName: string, fieldName: string): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (fieldName.Equal("Scale")) {
   //   if (mapScale < 0) {
   //      visible = false;
   //   }

   //} else if (fieldName.Equal("OtherField")) {
   //}

   return visible;
}

//Set custom angle for point graphic symbol labels.
export function getCustomLabelAngle(layerName: string, angle: number): number {
   let outAngle: number = angle;
   //outAngle = -angle;
   return outAngle;
}

//Set custom Arcade formatting expression for point feature class labels.
export function getCustomLabelFormatExpression(layerName: string): string {
   let expression: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (layerName.Equal("Place Names")) {
      if (mapScale < 0) {
         //IIF($feature.POPULATION > 10000, $feature.NAME + ' city', $feature.NAME + ' town')
         //expression = "'Address: ' + $feature.fieldName1 + TextFormatting.NewLine + $feature.fieldName2";
         //expression = "'Address: ' + $feature.scale";
      }

   } else if (layerName.Equal("OtherField")) {

   }

   return expression;
}

//Set custom sql where string for feature layer labels.
export function getCustomLabelQuery(layerName: string): string {
   let sql: string = null;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   //if (layerName.Equal("Place Names")) {
   //   if (mapScale < 0) {
   //      sql = "scale = 800";
   //   }

   //} else if (layerName.Equal("OtherField")) {
   //}

   return sql;
}

//Set custom visiblity for line and polygon feature layer label values.
export function getCustomLabelVisibility(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet): boolean {
   let visible: boolean = true;
   const trueScale: number = MainMap.mapView.scale;
   const mapScale: number = trueScale / 12;

   if (fieldName.Equal("BlaBla")) {
      const totalValue = Util_App.getGraphicAttributeValue("totalValue", feature) as number;
      if (totalValue < 300000 && mapScale < 400) {
         visible = false;
      }

   } else if (fieldName.Equal("OtherField")) {
   }

   return visible;
}

//Set custom text value for line and polygon feature layer label values.
export function getCustomLabelValue(fieldName: string, fieldValue: any, feature: __esri.Graphic, layerName: string, fs: __esri.FeatureSet): string {

   //if (fieldName.Equal("pin")) {
   //   fieldValue += " ac";

   //} else if (fieldName.Equal("OtherField")) {
   //}

   if (layerName.Equal("Municipal Boundaries")) {
      if (fieldValue === "S.D. COUNTY") {
         fieldValue = "S.D. County";
      } else {
         fieldValue = Util.makeTitleCase(fieldValue);
      }

   } else if (layerName.Equal("Census Block 2010")) {
      fieldValue = fieldValue.replace("Block ", "");

   } else if (layerName.Equal("Ground Water Basins")) {
      fieldValue = Util.makeTitleCase(fieldValue);

   } else if (layerName.Equal("Watershed")) {
      fieldValue = Util.makeTitleCase(fieldValue);

      //} else if (layerName.Equal("Park Trail")) {
      //   fieldValue = Util.makeTitleCase(fieldValue);

   } else if (layerName.Equal("General Plan Trail")) {
      fieldValue = Util.makeTitleCase(fieldValue);

   } else if (fieldName.Equal("Diameter")) {
      if (fieldValue && fieldValue !== null) {
         fieldValue = fieldValue + '"';
      }
      else {
         fieldValue = '';
      }

   } else if (layerName.Equal("Homeowner Associations")) {
      fieldValue = Util.makeTitleCase(fieldValue);

   } else if (layerName.Equal("Neighborhoods")) {
      fieldValue = Util.makeTitleCase(fieldValue);
   }

   return fieldValue as string;
}

//Set custom ESRI popup title html.
export function getCustomESRI_PopupTitleHTML(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet): string {
   let html: string = "";
   let pin: string;

   //Parcels.
   if (layerName === "Z Residential Sales") {
      pin = Util_App.getGraphicAttributeValue("PIN", feature) as string;
      html += '<span style="color: darkred; margin-left: 9px;">' + pin + '</span> ';

   } //End if layername parcels.
   return html;
}

//Set custom ESRI popup content html.
export function getCustomESRI_PopupContentHTML(layerName: string, feature: __esri.Graphic, fs: __esri.FeatureSet): string {
   let html: string = "";
   let pin: string;

   if (layerName === "Z Residential Sales") {
      pin = Util_App.getGraphicAttributeValue("PIN", feature) as string;
      html += '<span style="color: darkred; margin-left: 9px;">' + pin + '</span> ';

   } //End if layername parcels.

   return html;
}

//Call custom javascript functions.
export function callFunction(js: string) {
   const sa: string[] = js.replace("js:", "").split("|");
   let sa2: string[];
   const name: string = sa[0].trim();
   let oid: number;
   let layerName: string;
   let featureLayer: __esri.FeatureLayer;
   let attachment: __esri.AttachmentInfo;
   let attachments: __esri.AttachmentInfo;
   let url: string;

   if (name === "showCarousel") {
      if (sa.length > 1) {
         const urls: string[] = sa[1].split(",");
         Carousel.show("Photos and Sketches", urls, 400);
      }

   } else if (name === "showDataTable") {
      if (sa.length > 1) {
         sa2 = sa[1].split(",");
         const title: string = sa2[0].trim();
         const id: string = sa2[1].trim();
         DataTable.show(title, id);
      }

   } else if (name === "showCommunityInfo") {
      if (sa.length > 1) {
         const xy: string[] = sa[1].split(",");
         const x: number = Util.parseFlt(xy[0]);
         const y: number = Util.parseFlt(xy[1]);
         CommunityInfo.setCenterPnt(new Point({ x: x, y: y, spatialReference: MainMap.activeView.spatialReference }));
         DrawerMenu.showTool("Community Information");
      }

      //} else if (name === "showAttachment") {
      //   if (sa.length > 1) {
      //      sa2 = sa[1].split(",");
      //      layerName = sa2[0].trim();
      //      oid = Util.parseInteger(sa2[1]);

      //      featureLayer = Util_App.getLayerById(layerName) as __esri.FeatureLayer;

      //      if (featureLayer && featureLayer.capabilities.attachment && featureLayer.capabilities.attachment.supportsName) {
      //         const attachmentQuery = new AttachmentQuery( { objectIds: [oid] });

      //         featureLayer.queryAttachments(attachmentQuery).then(function (attachments: __esri.AttachmentInfo) {
      //            if (attachments[oid]) {
      //               attachment = attachments[oid][0];
      //               url = attachment.url + "/" + attachment.name;
      //               window.open(url, "Attachment");
      //            }

      //         }).catch(function (error: Error) {
      //            console.log("attachment query error", error);
      //         });
      //      }
      //   }

   }
}

//Get links.
function addToLinks(links: string, inLinks: string[]): string[] {
   let url: string;
   let outLinks: string[] = inLinks;

   if (!outLinks) {
      outLinks = [];
   }
   if (links && (links !== "")) {
      const sa: string[] = links.split(",");

      for (const txt of sa) {
         url = Settings.webServerURL + txt;
         outLinks.Add(url);
      }
   }
   return outLinks;
}

//Add dashes to PIN.
export function addDashesToPIN(pin: string): string {
   let i: number = 0;
   let c: string;
   let isNumber: boolean = true;
   let outPIN: string = pin;

   if ((pin.length === 10) && (!pin.Contains("-"))) {
      for (i = 0; i < pin.length; i++) {
         c = pin.charAt(i);
         if (!c.IsNumeric()) {
            isNumber = false;
            break;
         }
      }
      if (isNumber) {
         outPIN = pin.SubStr(0, 4) + "-";
         outPIN += pin.SubStr(4, 3) + "-";
         outPIN += pin.SubStr(7, 3);
      }
   }
   return outPIN;
}

//Open a custom link.
export function openLink(toolName: string) {
   let url: string;

   if (toolName === "Contact Us") {
      url = "./Help/faqs.html";
      window.open(url, "ContactUs");

   } else if (toolName === "Home") {
      url = "https://poway.org/784/Online-Maps";
      window.open(url, "Home");

   } else if (toolName === "Privacy Policy") {
      window.open(url, "PrivacyPolicy");

      //CUSTOM! Poway
   } else if (toolName === "Help") {
      url = "./Help/home.html";
      window.open(url, "Help");

      //CUSTOM! Poway
   } else if (toolName === "Apps and Maps") {
      url = "https://geohub-poway.hub.arcgis.com/pages/apps-and-maps";
      window.open(url, "AppsandMaps");

      //CUSTOM! Poway
   } else if (toolName === "Open Data") {
      url = "https://geohub-poway.hub.arcgis.com/pages/open-data";
      window.open(url, "OpenData");

      //CUSTOM! Poway
   } else if (toolName === "Print Maps") {
      url = "https://geohub-poway.hub.arcgis.com/pages/print-maps";
      window.open(url, "PrintMaps");
   }
}
